import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../config';
import '../styles/searchusers.css';
import ProfilePicture from '../components/ProfilePicture';

const SearchUsers = () => {
    const [searchTerm, setSearchTerm] = useState('');
    const [users, setUsers] = useState([]);
    const [featuredUsers, setFeaturedUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const currentUserId = window.localStorage.getItem('userID');

    useEffect(() => {
        fetchFeaturedUsers();
    }, []);

    const fetchFeaturedUsers = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_BASE_URL}/users/featured`);
            console.log('Featured users response:', response.data);
            setFeaturedUsers(response.data.users.filter(user => user._id !== currentUserId));
        } catch (error) {
            console.error('Error fetching featured users:', error);
            setError('Error loading featured users');
        } finally {
            setLoading(false);
        }
    };

    const searchUsers = async (e) => {
        e.preventDefault();
        if (!searchTerm.trim()) return;

        try {
            setLoading(true);
            setError(null);
            const response = await axios.get(`${API_BASE_URL}/users/search?username=${searchTerm}`);
            console.log('Search response:', response.data);
            setUsers(response.data.users.filter(user => user._id !== currentUserId));
        } catch (error) {
            console.error('Error searching users:', error);
            setError(error.response?.data?.message || 'Error searching users');
        } finally {
            setLoading(false);
        }
    };

    const UserCard = ({ user }) => (
        <div key={user._id} className="user-card">
            <ProfilePicture
                src={user.profilePicture}
                alt={user.username}
                className="user-avatar"
            />
            <div className="user-info">
                <h3>{user.username}</h3>
                <p>{user.bio || 'No bio yet'}</p>
                <div className="user-stats">
                    <span>{user.followers?.length || 0} followers</span>
                    <span>{user.recipesCount || 0} recipes</span>
                </div>
                <Link to={`/profile/${user._id}`} className="view-profile-button">
                    View Profile
                </Link>
            </div>
        </div>
    );

    return (
        <div className="search-users-container">
            <h2>Find Users</h2>
            <form onSubmit={searchUsers} className="search-form">
                <input
                    type="text"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    placeholder="Search by username..."
                    className="search-input"
                />
                <button type="submit" className="search-button">Search</button>
            </form>

            {loading && <div className="loading">Loading...</div>}
            {error && <div className="error">{error}</div>}

            {searchTerm ? (
                <div className="search-results">
                    <h3>Search Results</h3>
                    <div className="users-grid">
                        {users.map(user => (
                            <UserCard key={user._id} user={user} />
                        ))}
                        {!loading && !error && users.length === 0 && (
                            <div className="no-results">No users found</div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="featured-users">
                    <h3>Featured Users</h3>
                    <div className="users-grid">
                        {featuredUsers.map(user => (
                            <UserCard key={user._id} user={user} />
                        ))}
                        {featuredUsers.length === 0 && !loading && (
                            <div className="no-results">No featured users available</div>
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default SearchUsers; 